import { ActionTypes } from "../constants/action-types"

const initialState = {
  interviewQaById: []
}

const FetchInterviewQaById = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.FETCH_INTERVIEW_QA_BY_ID : return {...state, 
            interviewQaById: payload}           
        default: return state;
    }
    
}


export default FetchInterviewQaById;